import { defineStyleConfig } from "@chakra-ui/react";
import { focusRing } from "../foundations/focus";

export const CloseButton = defineStyleConfig({ baseStyle: { _focusVisible: focusRing } });
